import {Price} from "../domin/pay/Price";

// 环境常量
export const PROD = "prod";
export const STAGE = "stage";
export const LOCAL = "local";
export const BUILD_DEV = "development";
export const BUILD_PROD = "production";

// 图片处理配置
export const IMAGE_PREFIX = 'image-handle';
export const IMAGE_VERSION = '1.0';

const normalizeApiEnvironment = (apiEnv) => {
    return apiEnv === PROD ? PROD : STAGE;
};

const normalizeImageEnvironment = (imageEnv) => {
    if (imageEnv === PROD || imageEnv === STAGE || imageEnv === LOCAL) {
        return imageEnv;
    }
    return LOCAL;
};

export const getBuildMode = () => {
    return process.env.NODE_ENV === BUILD_PROD ? BUILD_PROD : BUILD_DEV;
};

export const isDevelopmentBuild = () => {
    return getBuildMode() === BUILD_DEV;
};

export const getApiEnvironment = () => {
    return normalizeApiEnvironment(process.env.API_ENV);
};

export const getImageEnvironment = () => {
    return normalizeImageEnvironment(process.env.IMAGE_ENV);
};

export const getVersion = () => {
    return process.env.RELEASE_ENV || "";
};

export const isProd = () => {
    return getApiEnvironment() === PROD;
};

export const IMAGE_ENV_CONFIG = {
    [PROD]: {
        imageBaseUrl: 'https://caloapp.ai',
        sitePath: '/site/prod',
        imageProcess: {
            prefix: IMAGE_PREFIX,
            version: IMAGE_VERSION,
            quality: 85,
            format: 'webp'
        }
    },
    [STAGE]: {
        imageBaseUrl: 'https://website-stage.caloapp.ai',
        sitePath: '/site/stage',
        imageProcess: {
            prefix: IMAGE_PREFIX,
            version: IMAGE_VERSION,
            quality: 90,
            format: 'webp'
        },
    },
    [LOCAL]: {
        imageBaseUrl: '',
        sitePath: '',
        imageProcess: {
            prefix: '',
            version: '',
            quality: 100,
            format: 'png'
        }
    }
};

export const API_ENV_CONFIG = {
    [PROD]: {
        appServiceBaseUrl: 'https://app-service.foodscannerai.com',
        countryApiUrl: 'https://gw.caloapp.ai/ip/api/v1/ip/ip2country',
        trackingApiUrl: 'https://gw.caloapp.ai/tracking'
    },
    [STAGE]: {
        appServiceBaseUrl: 'https://app-service-stage.foodscannerai.com',
        countryApiUrl: 'https://gw-stage.caloapp.ai/ip/api/v1/ip/ip2country',
        trackingApiUrl: 'https://gw-stage.caloapp.ai/tracking'
    }
};

export const getCurrentImageEnvConfig = () => {
    const imageEnv = getImageEnvironment();
    return IMAGE_ENV_CONFIG[imageEnv] || IMAGE_ENV_CONFIG[LOCAL];
};

export const getCurrentApiEnvConfig = () => {
    const apiEnv = getApiEnvironment();
    return API_ENV_CONFIG[apiEnv] || API_ENV_CONFIG[STAGE];
};

export const getCurrentWebsiteBaseUrl = () => {
    if (getImageEnvironment() === LOCAL) {
        return typeof window !== "undefined" ? window.location.origin : "http://localhost";
    }
    return getCurrentImageEnvConfig().imageBaseUrl;
};

export const COUNTRY_API = API_ENV_CONFIG[PROD].countryApiUrl;
export const COUNTRY_STAGE_API = API_ENV_CONFIG[STAGE].countryApiUrl;

export const TRACKING_STAGE_API = API_ENV_CONFIG[STAGE].trackingApiUrl;
export const TRACKING_PROD_API = API_ENV_CONFIG[PROD].trackingApiUrl;

let oneWeekPrices = 17.77;
let fourWeekPrices = 38.95;
let twelveWeekPrices = 66.65;

export const getSKUS = () => {
    if (isProd()) {
        return [{
            discount: 0,
            prices: [
                new Price({
                    week: 1,
                    price: oneWeekPrices,
                    paypal: "P-0PR70151SL513723UNEA7P6A",
                    stripe: "prod_TKCqY2pKGhlhZq",
                    dynamicCycleSubscription: true,
                    id: "d0_1w_to_4w",
                    finalWeek: 4,
                    finalPrice: fourWeekPrices
                }),
                new Price({
                    week: 4,
                    price: fourWeekPrices,
                    paypal: "P-3EX285621E1463439NEA7SDQ",
                    stripe: "prod_TKCqY2pKGhlhZq",
                    dynamicCycleSubscription: false,
                    id: "d0_4w"
                }),
                new Price({
                    week: 12,
                    price: twelveWeekPrices,
                    paypal: "P-9MV110019K298110JNEA7UHQ",
                    stripe: "prod_TKCrMODj7ghpcf",
                    dynamicCycleSubscription: false,
                    id: "d0_12w"
                }),
            ]
        },{
            discount: 61,
            prices: [
                new Price({
                    week: 1,
                    price: 6.93,
                    paypal: "P-75X90082K8192960RNEA7QZY",
                    stripe: "prod_TKCqY2pKGhlhZq",
                    dynamicCycleSubscription: true,
                    id: "d61_1w_to_4w",
                    finalWeek: 4,
                    finalPrice: fourWeekPrices
                }),
                new Price({
                    week: 4,
                    price: 15.19,
                    paypal: "P-2UU187075Y557752XNEA7TAA",
                    stripe: "prod_TKCqY2pKGhlhZq",
                    dynamicCycleSubscription: false,
                    id: "d61_4w",
                    finalPrice: fourWeekPrices
                }),
                new Price({
                    week: 12,
                    price: 25.99,
                    paypal: "P-1BV537741T526882MNEA7UWI",
                    stripe: "prod_TKCrMODj7ghpcf",
                    dynamicCycleSubscription: false,
                    id: "d61_12w",
                    finalPrice: twelveWeekPrices
                }),
            ]
        },{
            discount: 71,
            prices: [
                new Price({
                    week: 1,
                    price: 5.15,
                    paypal: "P-7FH39503VE193671YNEA7RRI",
                    stripe: "prod_TKCqY2pKGhlhZq",
                    dynamicCycleSubscription: true,
                    id: "d71_1w_to_4w",
                    finalWeek: 4,
                    finalPrice: fourWeekPrices
                }),
                new Price({
                    week: 4,
                    price: 11.29,
                    paypal: "P-3DY60730M5473054UNEA7TXY",
                    stripe: "prod_TKCqY2pKGhlhZq",
                    dynamicCycleSubscription: false,
                    id: "d71_4w",
                    finalPrice: fourWeekPrices
                }),
                new Price({
                    week: 12,
                    price: 19.29,
                    paypal: "P-0W5489048R222330ANEA7VCI",
                    stripe: "prod_TKCrMODj7ghpcf",
                    dynamicCycleSubscription: false,
                    id: "d71_12w",
                    finalPrice: twelveWeekPrices
                }),
            ]
        }]
    }
    return [{
        discount: 0,
        weekToMonth: true,
        prices: [
            new Price({
                week: 1,
                price: oneWeekPrices,
                paypal: "P-97G43329S6600522JNEA4ZZQ",
                stripe: "prod_SVWlfWCUeEeQYc",
                dynamicCycleSubscription: true,
                id: "d0_1w_to_4w",
                finalWeek: 4,
                finalPrice: fourWeekPrices
            }),
            new Price({
                week: 4,
                price: fourWeekPrices,
                paypal: "P-2YB37581XB888462TNBH3ERI",
                stripe: "prod_SVWlfWCUeEeQYc",
                dynamicCycleSubscription: false,
                id: "d0_4w"
            }),
            new Price({
                week: 12,
                price: twelveWeekPrices,
                paypal: "P-8BR93125YL818893MNBH3EZY",
                stripe: "prod_SVWm2GxizDqnsP",
                dynamicCycleSubscription: false,
                id: "d0_12w"
            }),
        ]
    },{
        discount: 61,
        prices: [
            new Price({
                week: 1,
                price: 6.93,
                paypal: "P-5D4597966T0202219NEA43WA",
                stripe: "prod_SVWlfWCUeEeQYc",
                dynamicCycleSubscription: true,
                id: "d61_1w_to_4w",
                finalWeek: 4,
                finalPrice: fourWeekPrices
            }),
            new Price({
                week: 4,
                price: 15.19,
                paypal: "P-7AJ211098C227813PNBH3GCQ",
                stripe: "prod_SVWlfWCUeEeQYc",
                dynamicCycleSubscription: false,
                id: "d61_4w",
                finalPrice: fourWeekPrices
            }),
            new Price({
                week: 12,
                price: 25.99,
                paypal: "P-44U69739P5457513WNBH3GPA",
                stripe: "prod_SVWm2GxizDqnsP",
                dynamicCycleSubscription: false,
                id: "d61_12w",
                finalPrice: twelveWeekPrices
            }),
        ]
    },{
        discount: 71,
        prices: [
            new Price({
                week: 1,
                price: 5.15,
                paypal: "P-39467743MF8813200NEA44EA",
                stripe: "prod_SVWlfWCUeEeQYc",
                dynamicCycleSubscription: true,
                id: "d71_1w_to_4w",
                finalWeek: 4,
                finalPrice: fourWeekPrices
            }),
            new Price({
                week: 4,
                price: 11.29,
                paypal: "P-7H567642A63678531NBH3HRI",
                stripe: "prod_SVWlfWCUeEeQYc",
                dynamicCycleSubscription: false,
                id: "d71_4w",
                finalPrice: fourWeekPrices
            }),
            new Price({
                week: 12,
                price: 19.29,
                paypal: "P-0MX52635EN594660DNBH3H2Y",
                stripe: "prod_SVWm2GxizDqnsP",
                dynamicCycleSubscription: false,
                id: "d71_12w",
                finalPrice: twelveWeekPrices
            }),
        ]
    }]
}
